import React from "react";
import Headers from "../../../components/Headers";
import { Input, Form, Row, Col, Button, Table, Divider, message } from "antd";
import EditBusinessModal from "../components/EditBusinessModal";
import BindEquipmentModal from "../components/BindEquipmentModal";
import { fetchBusinessList, fetchUnbindList } from "../../../api/business";
import NProgress from "nprogress";
import { Link } from "react-router-dom";
import { Decrypt } from "../../../utils/secret";
const BreadCrumbData = [{ path: "/page/business/business", name: "商户" }];
const { Column } = Table;
class Business extends React.Component {
  state = {
    type: "SHARE",
    confirm: false,
    equipmentList: [],
    isAdd: true,
    editBusinessModalvisible: false,
    bindEquipmentModalvisible: false,
    businessInfo: {
      companyId: "",
      companyName: "",
      contacts: "",
      hasCapsule: "",
      mobilePhone: "",
      telephone: "",
    },
    list: [],
    listQuery: { companyName: "", pageSize: 10, pageNum: 1 },
    total: 0,
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log(values);

        this.setState(
          {
            listQuery: { ...this.state.listQuery, ...values, pageNum: 1 },
          },
          () => {
            this.getBusinessList();
            message.success("搜索成功");
          }
        );
      }
    });
  };
  async componentDidMount() {
    NProgress.start();
    await this.getBusinessList();
    NProgress.done();
  }
  getBusinessList = () => {
    fetchBusinessList(this.state.listQuery).then((res) => {
      if (res.data.list) {
        res.data.list.forEach((item) => {
          item.mobilePhone = Decrypt(item.mobilePhone);
          item.telephone = Decrypt(item.telephone);
        });
      }
      this.setState({
        list: res.data.list,
        total: res.data.total,
      });
    });
  };
  handleCancel1 = () => {
    this.setState({
      editBusinessModalvisible: false,
      businessInfo: {
        companyId: "",
        companyName: "",
        contacts: "",
        hasCapsule: "",
        mobilePhone: "",
        telephone: "",
      },
    });
  };
  setConfirm = () => {
    this.setState({
      confirm: true,
    });
  };
  setConfirmFalse = () => {
    this.setState({
      confirm: false,
    });
  };
  handleCancel2 = () => {
    this.setState({
      type: "SHARE",
      confirm: false,
      bindEquipmentModalvisible: false,
      businessInfo: {
        companyId: "",
        companyName: "",
        contacts: "",
        hasCapsule: "",
        mobilePhone: "",
        telephone: "",
      },
    });
  };
  radioChange = (e) => {
    this.setState({
      type: e.target.value,
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      list,
      listQuery,
      total,
      editBusinessModalvisible,
      bindEquipmentModalvisible,
      isAdd,
      businessInfo,
      equipmentList,
      confirm,
      type,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="searchTitle">
          <Row>
            <Col span={18}>
              <Form layout="inline" onSubmit={this.handleSubmit}>
                <Form.Item>
                  {getFieldDecorator(
                    "companyName",
                    {}
                  )(
                    <Input
                      style={{ width: 200 }}
                      placeholder="商户"
                      allowClear
                    />
                  )}
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    搜索
                  </Button>
                </Form.Item>
              </Form>
            </Col>
            <Col span={6} align="right">
              <Button
                type="primary"
                onClick={() =>
                  this.setState({ editBusinessModalvisible: true, isAdd: true })
                }
              >
                添加商户
              </Button>
            </Col>
          </Row>
        </div>
        <div className="content">
          <Table
            rowKey="companyId"
            dataSource={list}
            // locale={{ emptyText: "暂无商户" }}
            pagination={{
              showTotal: () => `共${total}条`,
              total: total,
              current: listQuery.pageNum,
              pageSize: listQuery.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "40", "100"],
              onChange: (page, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageNum: page },
                  },
                  () => this.getBusinessList()
                );
              },
              onShowSizeChange: (current, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageSize, pageNum: 1 },
                  },
                  () => this.getBusinessList()
                );
              },
            }}
          >
            <Column
              title="商户名称"
              dataIndex="companyName"
              key="companyName"
            />
            <Column title="联系人" dataIndex="contacts" key="contacts" />
            <Column title="联系电话" dataIndex="telephone" key="telephone" />
            <Column
              title="登录账号"
              dataIndex="mobilePhone"
              key="mobilePhone"
            />
            <Column
              title="操作"
              render={(text, record) => {
                return (
                  <React.Fragment>
                    <a
                      onClick={() => {
                        this.setState({
                          businessInfo: record,
                          editBusinessModalvisible: true,
                          isAdd: false,
                        });
                      }}
                    >
                      编辑商户
                    </a>
                    <Divider type="vertical" />

                    <a
                      onClick={() => {
                        this.setState({
                          businessInfo: record,
                          bindEquipmentModalvisible: true,
                        });
                        fetchUnbindList().then((res) => {
                          console.log(res);
                          this.setState({
                            equipmentList: res.data,
                          });
                        });
                      }}
                    >
                      绑定设备
                    </a>
                    {record.hasCapsule ? (
                      <React.Fragment>
                        {" "}
                        <Divider type="vertical" />
                        <a
                          onClick={() =>
                            this.props.history.push(
                              `/page/tenant/viewequipment/${record.companyId}`
                            )
                          }
                        >
                          查看设备
                        </a>
                      </React.Fragment>
                    ) : null}
                    {/* <Divider type="vertical" />

                    <Link
                      to={`/page/business/business/viewShop/${record.companyId}`}
                    >
                      查看店铺
                    </Link> */}
                  </React.Fragment>
                );
              }}
            />
          </Table>
        </div>
        <EditBusinessModal
          businessInfo={businessInfo}
          isAdd={isAdd}
          visible={editBusinessModalvisible}
          handleCancel={this.handleCancel1}
          getBusinessList={this.getBusinessList}
        ></EditBusinessModal>
        <BindEquipmentModal
          destroyOnClose
          visible={bindEquipmentModalvisible}
          handleCancel={this.handleCancel2}
          getBusinessList={this.getBusinessList}
          businessInfo={businessInfo}
          equipmentList={equipmentList}
          confirm={confirm}
          setConfirm={this.setConfirm}
          radioChange={this.radioChange}
          setConfirmFalse={this.setConfirmFalse}
          type={type}
        ></BindEquipmentModal>
      </div>
    );
  }
}
export default Form.create()(Business);
